import React, { useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import './KycStyles.css';

export default function SubmitPage() {
  const location = useLocation();
  const { token } = useParams();
  const { selfieImage, idFrontImage, idBackImage } = location.state || {};
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    // Convert base64 to Blob
    function base64ToBlob(base64, mime = "image/jpeg") {
      const byteString = atob(base64.split(",")[1]);
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], { type: mime });
    }

    const formData = new FormData();
    if (idFrontImage) formData.append("front_id_pic", base64ToBlob(idFrontImage), "front_id.jpg");
    if (idBackImage) formData.append("back_id_pic", base64ToBlob(idBackImage), "back_id.jpg");
    if (selfieImage) formData.append("face_pic", base64ToBlob(selfieImage), "face.jpg");

    try {
      const response = await fetch("https://api.swapuzi.com/upload_kyc_images", {
        method: "POST",
        body: formData,
        headers: {
          "Authorization": `Bearer ${token}`
        },
      });
      if (!response.ok) throw new Error("Upload failed");
      setSubmitted(true);
    } catch (err) {
      alert("Failed to submit: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="kyc-container">
        <div className="kyc-progress"><div className="kyc-progress-bar" style={{width: '100%'}} /></div>
        <h2 className="kyc-title">KYC Submitted!</h2>
        <p className="kyc-desc">Thank you. Your verification is being processed.</p>
      </div>
    );
  }

  return (
    <div className="kyc-container">
      <div className="kyc-progress"><div className="kyc-progress-bar" style={{width: '100%'}} /></div>
      <h2 className="kyc-title">Review & Submit</h2>
      <div className="kyc-thumbnails">
        <div>
          <p>Selfie</p>
          <img src={selfieImage} alt="Selfie" className="kyc-thumb" />
        </div>
        <div>
          <p>ID Front</p>
          <img src={idFrontImage} alt="ID Front" className="kyc-thumb" />
        </div>
        <div>
          <p>ID Back</p>
          <img src={idBackImage} alt="ID Back" className="kyc-thumb" />
        </div>
      </div>
      <button className="kyc-submit-btn" onClick={handleSubmit} disabled={loading}>
        {loading ? 'Submitting...' : 'Submit'}
      </button>
    </div>
  );
} 